import { axiosAdmin } from "config/axios.config";

const MENU_URL = "/doc/menu";

const channelSvc = {
  getAll: async () => {
    const title = ["titles"];
    const params = new URLSearchParams({
      include: `["${title}"]`,
    }).toString();

    const response = await axiosAdmin.get(`${MENU_URL}?${params}`);
    return response;
  },
};

export default channelSvc;
